<template>
  <div>
    <device-upper-section :device="device" :segment="$props.segment"/>
    <device-specs-tariff-wrapper v-if="device && Object.keys(device).length"
                                 :device-specification="deviceSpecs"
                                 :productOffering="productOffering"/>
    <flash-message :position="'right bottom'"></flash-message>
    <base-full-loader/>
  </div>
</template>

<script>
import DeviceUpperSection from '@/components/pdp/device-upper-section'
import DeviceSpecsTariffWrapper from '@/components/pdp/device-specs-tariff-wrapper'

export default {
  name: 'view-pdp-page',
  components: {
    DeviceSpecsTariffWrapper,
    DeviceUpperSection
  },
  created () {
    window.addEventListener('popstate', () => {
      window.location.search = ''
      window.history.back()
    })
    this.flashMessage.setStrategy('multiple')
  },
  data () {
    return {
      device: Object.freeze(JSON.parse(this.$props.productDetails))
    }
  },
  computed: {
    deviceSpecs () {
      return this.device && this.device.classifications
    },
    productOffering () {
      return this.device.productOfferingPrices.filter((item, index) => {
        if (item.tariff) {
          return this.device.productOfferingPrices.findIndex(element => element.tariff.code === item.tariff.code) === index
        }
      })
    }
  },
  props: {
    productDetails: {
      type: String,
      default: '{}'
    },
    segment: String
  }
}
</script>
